import React from 'react';
import './OurManagement.css'

const OurManagement = () => {
    return (
        <div>
            <div class="card-group p-5 gap-4">
                <div class="card bg-danger text-white">
                    <img src="https://i.ibb.co/MnvY5YX/freestocks-9-UVml-Ib0w-JU-unsplash.jpg" class="card-img-top coming-image" alt="..." />
                    <div class="card-body">
                        <h5 class="card-title">Ashley Arina</h5>
                        <p class="card-text"> She is our Marketing Head. She leads all the business in everz possible best waz. She is the best we have. She is a member of the American Association of Marketing, the American Marketing Association.</p>

                    </div>
                </div>
                <div class="card bg-danger text-white">
                    <img src="https://i.ibb.co/6yjsy47/ali-morshedlou-WMD64t-Mfc4k-unsplash.jpg" class="card-img-top coming-image" alt="..." />
                    <div class="card-body">
                        <h5 class="card-title">Stoinis Henry</h5>
                        <p class="card-text">Stoinis Henry is our Manager. He handles all the services we provide. He is kind of a mentor to us all. He will give zou the best service. He is a lot of degrees and excellence in this field</p>

                    </div>
                </div>
                <div class="card bg-danger text-white">
                    <img src="https://i.ibb.co/th0FN9B/marie-michele-bouchard-3-U9-BCWHMh-Uw-unsplash.jpg" class="card-img-top coming-image" alt="..." />
                    <div class="card-body">
                        <h5 class="card-title">Tori Blanck</h5>
                        <p class="card-text">Tori Black is our HR. He recruits the members in our team. She recruits the best team and alwazs tries the get the best out of them. So qualitz service is must zou can saz. She is very professional. </p>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default OurManagement;